const initialState = {
  access_token: "",
  displayName: "",
  role: "",
  token_type: "",
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_DATA": {
      return {
        ...state,
        access_token: action.access_token,
        displayName: action.displayName,
        role: action.role,
        token_type: action.token_type,
      };
    }
    case "REMOVE_DATA": {
      return {
        ...state,
        access_token: null,
        displayName: null,
        role: null,
        token_type: null,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
